import React, { useState, useEffect, useRef } from "react";
import axios from "../../api/axiosConfig";
import ImageCarouselLoader from "../loaders/ImageCarouselLoader";

export default function RecipeImages({ recipeId, existingImages, defaultImage }) {
  const [images, setImages] = useState(existingImages || null);
  const [loadingImages, setLoadingImages] = useState(!existingImages);
  const hasFetched = useRef(false); // ✅ Prevents duplicate API calls

  useEffect(() => {
    if (!recipeId || hasFetched.current || existingImages) return; // ✅ Skip if data already exists
    hasFetched.current = true;

    console.log(`Fetching images for recipe: ${recipeId}`);
    setLoadingImages(true);

    axios
      .post("/api/recipe/images", { recipeId })
      .then((response) => setImages(response.data))
      .catch((err) => console.error("Error fetching images:", err))
      .finally(() => setLoadingImages(false));
  }, [recipeId, existingImages]);

  return (
    <>
      {loadingImages ? (
        <ImageCarouselLoader />
      ) : images?.length > 0 ? (
        <div className="relative">
          <div className="flex overflow-x-scroll scrollbar-hide">
            {images.map((image, index) => (
              <div key={index} className={`flex-shrink-0 w-64 sm:w-80 ${index === 0 ? "" : "ml-2"}`}>
                <img src={image} alt={`Recipe Image ${index + 1}`} className="w-full h-64 sm:h-80 object-cover rounded-lg" />
              </div>
            ))}
          </div>
        </div>
      ) : defaultImage ? (
        <div className="relative">
          <div className="flex overflow-x-scroll scrollbar-hide">
            <div className={`flex-shrink-0 w-64 sm:w-80 `}>
              <img src={defaultImage} alt={`Default recipe image`} className="w-full h-64 sm:h-80 object-cover rounded-lg" />
            </div>
          </div>
        </div>
      ) : (
        <p className="text-gray-500">No images available</p>
      )}
    </>
  );
}
